var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "quickIndemnity" } },
    [
      _c(
        "div",
        { staticClass: "yto-box search-form y-pb-0" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.form, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "time-style",
                      attrs: { prop: "createTime", "label-width": "0" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "timetype-style",
                          attrs: { placeholder: "活动区域" },
                          model: {
                            value: _vm.form.timeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "timeType", $$v)
                            },
                            expression: "form.timeType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "发起时间", value: "createTime" },
                          }),
                          _c("el-option", {
                            attrs: { label: "打款时间", value: "remitTime" },
                          }),
                        ],
                        1
                      ),
                      _c("yto-date-picker", {
                        staticClass: "date-style",
                        attrs: {
                          maxRangeVal: 31,
                          "picker-options": _vm.pickerOptions,
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          clearable: false,
                        },
                        model: {
                          value: _vm.form.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "createTime", $$v)
                          },
                          expression: "form.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "indemnityType", label: "理赔类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.indemnityType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "indemnityType", $$v)
                            },
                            expression: "form.indemnityType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._l(_vm.indemnityTypeList, function (item) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: { label: item.name, value: item.code },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "运单号", prop: "waybillNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.waybillNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "waybillNo", $$v)
                          },
                          expression: "form.waybillNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺名称", prop: "mallCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.mallCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mallCode", $$v)
                            },
                            expression: "form.mallCode",
                          },
                        },
                        _vm._l(_vm.mallList, function (item) {
                          return _c("el-option", {
                            key: item.mallCode,
                            attrs: {
                              label: item.mallName,
                              value: item.mallCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "流水号", prop: "remitSerialNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.remitSerialNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remitSerialNo", $$v)
                          },
                          expression: "form.remitSerialNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { float: "right", "margin-right": "0" } },
                    [
                      _c(
                        "div",
                        { staticClass: "button-group" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pageChange(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "normal-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("searchForm")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-refresh-left y-fc-4C84FF",
                              }),
                              _vm._v("重置"),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                loading: _vm.exportLoading,
                                disabled: _vm.tableLoading || _vm.total === 0,
                              },
                              on: { click: _vm.exportFile },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-download y-fc-4C84FF",
                              }),
                              _vm._v("导出"),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "yto-box y-pb-0" }, [
        _c(
          "div",
          { staticClass: "y-mb-20 y-t-al y-f y-f-a" },
          [
            _c(
              "el-button",
              {
                staticClass: "normal-btn setting-btn",
                on: { click: _vm.openCollecAccount },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/icon_shoukuanzhanghu.png"),
                  },
                }),
                _vm._v("设置店铺收款账号"),
              ]
            ),
            _c(
              "el-alert",
              {
                staticClass: "y-d-ib alert-style",
                attrs: { "show-icon": "", closable: false },
              },
              [
                _c("span", [
                  _vm._v(
                    "店铺收款账号设置后，产生的快速理赔款将直接打款至店铺对应的支付宝账号中"
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yto-table" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "waybillNo",
                    label: "运单号",
                    align: "center",
                    "min-width": "130px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "hilightColor",
                              on: {
                                click: function ($event) {
                                  return _vm.showWaybillDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.waybillNo))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "mallName",
                    label: "店铺名称",
                    align: "center",
                    "min-width": "150px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(
                          scope.row.mallInfos,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "y-f y-f-jc y-f-as" },
                              [
                                _c("svg-icon", {
                                  staticClass:
                                    "custom-table-list-svg y-mr-5 y-f-shrink",
                                  attrs: {
                                    iconClass:
                                      _vm.PLATFORMICONMAP[item.platformCode],
                                  },
                                }),
                                _c("span", { staticClass: "y-fl-18" }, [
                                  _vm._v(_vm._s(item.mallName)),
                                ]),
                              ],
                              1
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityType",
                    label: "理赔类型",
                    align: "center",
                    "min-width": "80px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(_vm.indemnityTypeList, function (item) {
                          return _c(
                            "span",
                            { key: item.code },
                            [
                              item.code == scope.row.indemnityType
                                ? [_vm._v(_vm._s(item.name))]
                                : _vm._e(),
                            ],
                            2
                          )
                        })
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityGoodsWorth",
                    label: "物品价值(元)",
                    align: "center",
                    "min-width": "90px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityAmount",
                    label: "理赔金额(元)",
                    align: "center",
                    "min-width": "90px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "理赔发起时间",
                    align: "center",
                    "min-width": "150px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remitAmount",
                    label: "赔付金额(元)",
                    align: "center",
                    "min-width": "90px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remitStatus",
                    label: "打款状态",
                    align: "center",
                    "min-width": "100px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "y-f y-f-jc" }, [
                            _c("div", { staticClass: "y-w-70 y-f y-f-a" }, [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.remitStatus)),
                              ]),
                              scope.row.quickPayFlag
                                ? _c("img", {
                                    staticClass: "y-w-25 y-h-25",
                                    attrs: {
                                      src: require("@/assets/images/message/icon_shot@2x.png"),
                                    },
                                  })
                                : _c("div", { staticClass: "y-w-25" }),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remitAccount",
                    label: "收款账号",
                    align: "center",
                    "min-width": "100px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.quickPayType == 1
                            ? _c("span", [_vm._v("-")])
                            : _c(
                                "div",
                                { staticClass: "y-f y-f-jc y-f-a" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.remitAccount)),
                                  ]),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        width: "100",
                                        trigger: "click",
                                        content: _vm.nerRemitAccount,
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "view-img-style",
                                        attrs: {
                                          slot: "reference",
                                          src: require("@/assets/images/view-blue.png"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.viewRemitAccount(
                                              scope.row
                                            )
                                          },
                                        },
                                        slot: "reference",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remitSerialNo",
                    label: "打款流水号",
                    align: "center",
                    "min-width": "150px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.quickPayType == 1
                            ? _c("span", [_vm._v("-")])
                            : _vm._e(),
                          _c("span", { attrs: { "w-else": "" } }, [
                            _vm._v(_vm._s(scope.row.remitSerialNo)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remitTime",
                    label: "打款时间",
                    align: "center",
                    "min-width": "150px",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "indemnityType",
                    label: "操作",
                    align: "center",
                    "min-width": "80px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.quickPayType == 1
                            ? _c("span", [_vm._v("-")])
                            : _c("div", [
                                scope.row.alipaySerialNo
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "y-fc-4C84FF y-c-p",
                                        on: {
                                          click: function ($event) {
                                            return _vm.dowloadEleImage(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("电子回单下载")]
                                    )
                                  : _vm._e(),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50],
                "page-size": _vm.pageSize,
                total: _vm.total,
                layout: "total, sizes, prev, pager, next",
              },
              on: {
                "size-change": _vm.limitChange,
                "current-change": _vm.pageChange,
                "update:currentPage": function ($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm.showDialog
        ? _c("orderTrackingDetails", {
            ref: "orderTrackingDetails",
            attrs: { value: _vm.showDialog, data: _vm.orderDetailsData },
            on: { close: _vm.closeDetailInfo },
          })
        : _vm._e(),
      _vm.collecAccountDialog
        ? _c("set-collect-account", {
            ref: "setCollecAccount",
            attrs: {
              value: _vm.collecAccountDialog,
              data: _vm.collecAccountData,
            },
            on: { close: _vm.closeCollecAccount },
          })
        : _vm._e(),
      _vm.realNameDialog
        ? _c("real-name", {
            ref: "realName",
            attrs: { value: _vm.realNameDialog, data: _vm.realNameData },
            on: { close: _vm.closeRealName },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }